/**
 * Auth 패키지 설정 타입 정의
 * 각 앱별로 다른 OAuth2 및 API 설정을 주입할 수 있도록 함
 */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
// 기본 설정값
export var DEFAULT_AUTH_CONFIG = {
    storage: {
        tokenKey: 'auth_token',
        userKey: 'auth_user',
        refreshTokenKey: 'auth_refresh_token',
        idTokenKey: 'auth_id_token',
        tokenTypeKey: 'auth_token_type',
        tokenExpiresAtKey: 'auth_access_token_expires_at',
        storageType: 'localStorage'
    },
    debug: false
};
// 앱별 기본 설정 템플릿
export var createDefaultConfig = function(appName) {
    return _object_spread({
        appName: appName,
        api: {
            baseUrl: "https://api.ugot.uk",
            authServerUrl: 'https://auth.ugot.uk'
        },
        oauth2: {
            clientId: "".concat(appName, "-client"),
            redirectUri: "https://app.ugot.uk/oauth2/redirect",
            logoutRedirectUri: "https://app.ugot.uk/logout",
            scopes: [
                'openid',
                'profile',
                'email'
            ]
        },
        routes: {
            loginPath: '/login',
            postLoginPath: '/'
        }
    }, DEFAULT_AUTH_CONFIG);
};
